const baseURL = "/v1/EventoCalendario";

const service = {
  methods: {
    $buscarEventoCalendarios(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarEventoCalendario({ params, id }) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $cadastrarEventoCalendario(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarEventoCalendario(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarEventoCalendario(id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
    }
  },
};

export default service;
